module.exports = __webpack_public_path__ + "static/media/dungeon.1fed9c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/backgrounds/dungeon.png
// module id = 244
// module chunks = 0